module.exports = __webpack_public_path__ + "static/media/logo-horizontal.06d3c552.svg";